import { PublicationStatusType, useOperatorByIdQuery } from "gql/generated";
import { useNavigate } from "react-router-dom";
import { useLoggedInAs, useSocialLinks } from "shared/hooks";
import { getTagPropsFromPublicationStatus } from "shared/utils";

type UseOperatorModalProps = {
  operatorId: string;
};

export const useOperatorModal = ({ operatorId }: UseOperatorModalProps) => {
  const loggedInAs = useLoggedInAs();
  const navigate = useNavigate();

  const { data, error, loading } = useOperatorByIdQuery({
    variables: { operatorId },
  });

  const { socialLinks, handleSocialClick } = useSocialLinks(
    data?.operatorById.contact.links,
  );

  const tagProps = getTagPropsFromPublicationStatus(
    data?.operatorById.status as PublicationStatusType,
  );

  const handleViewInDirectoryClick = () =>
    navigate(
      `/app/organization/${loggedInAs?.entityId ?? ""}/directory/${operatorId}`,
    );

  return {
    operator: data?.operatorById,
    error,
    loading,
    socialLinks,
    tagProps,
    handleSocialClick,
    handleViewInDirectoryClick,
  };
};
